module.exports = __webpack_public_path__ + "static/media/Carousel-1-small.bd0fa84f.svg";